module.exports = "/_next/static/images/Cover@2x-15f1634014ef0d3219644634aface972.webp";